import React, { Component } from "react";
import Button from "../../components/Button/Button";
import "./Footer.scss";
import Toastr from "toastr";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerName: "",
      whatsappNumber: "",
      email: "",
      optInAlerts: false,
      errors: {
        customerName: "",
        whatsappNumber: "",
        email: "",
        optInAlerts: ""
      }
    };
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let errors = { ...this.state.errors };

    if (name === "customerName") {
      if (!value.trim()) {
        errors.customerName = "Name is required.";
      } else if (!/^[A-Za-z ]+$/.test(value)) {
        errors.customerName = "Name must contain only letters and spaces.";
      } else {
        errors.customerName = "";
      }
    }
    if (name === "whatsappNumber") {
      if (!value.trim()) {
        errors.whatsappNumber = "WhatsApp number is required.";
      } else if (!/^\d{10}$/.test(value)) {
        errors.whatsappNumber = "WhatsApp number must be a valid 10-digit number.";
      } else {
        errors.whatsappNumber = "";
      }
    }
    if (name === "email") {
      if (!value.trim()) {
        errors.email = "Email is required.";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errors.email = "Please enter a valid email address.";
      } else {
        errors.email = "";
      }
    }
    if (name === "optInAlerts") {
      errors.optInAlerts = checked ? "" : "You must check the opt-in box to subscribe.";
    }

    this.setState({
      [name]: type === "checkbox" ? checked : value,
      errors
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { customerName, whatsappNumber, email, optInAlerts, errors } = this.state;
    const nameRegex = /^[A-Za-z ]+$/;
    const mobileRegex = /^\d{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let valid = true;
    let newErrors = { ...errors };

    if (!customerName.trim()) {
      newErrors.customerName = "Name is required.";
      valid = false;
    } else if (!nameRegex.test(customerName)) {
      newErrors.customerName = "Name must contain only letters and spaces.";
      valid = false;
    } else {
      newErrors.customerName = "";
    }

    if (!whatsappNumber.trim()) {
      newErrors.whatsappNumber = "WhatsApp number is required.";
      valid = false;
    } else if (!mobileRegex.test(whatsappNumber)) {
      newErrors.whatsappNumber = "WhatsApp number must be a valid 10-digit number.";
      valid = false;
    } else {
      newErrors.whatsappNumber = "";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    } else {
      newErrors.email = "";
    }

    if (!optInAlerts) {
      newErrors.optInAlerts = "You must check the opt-in box to subscribe.";
      valid = false;
    } else {
      newErrors.optInAlerts = "";
    }

    this.setState({ errors: newErrors });

    if (!valid) return;

    Toastr.success("form submitted successfully");

    this.setState({
      customerName: "",
      whatsappNumber: "",
      email: "",
      optInAlerts: false,
      errors: {
        customerName: "",
        whatsappNumber: "",
        email: "",
        optInAlerts: ""
      }
    });
  };

  handleReset = () => {
    this.setState({
      customerName: "",
      whatsappNumber: "",
      email: "",
      optInAlerts: false,
      errors: {
        customerName: "",
        whatsappNumber: "",
        email: "",
        optInAlerts: ""
      }
    });
  };

  render() {
    return (
      <>
        <div id="contact_us" className="footer_container">
          <img
            src="../../images/background_image.jpg"
            alt="Motilal Oswal Asset Management Company Limited"
          ></img>
          <section className="text_box">
            <p className="subscrption_heading">
             Opt-In Form
            </p>
            <div className="input-areas">
              <form onSubmit={this.handleSubmit} onReset={this.handleReset}>
                <div className="row mb-4">
                  <div className="col-md-4 col-sm-12 py-2">
                    <label htmlFor="customerName" style={{ fontWeight: 'bold' }}>Customer Name</label>
                    <input
                      type="text"
                      name="customerName"
                      id="customerName"
                      placeholder="Enter your full name"
                      className="footer-input-1 input_1"
                      value={this.state.customerName || ""}
                      onChange={this.handleChange}
                      required
                    />
                    {this.state.errors.customerName && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>{this.state.errors.customerName}</div>
                    )}
                  </div>
                  <div className="col-md-4 col-sm-12 py-2">
                    <label htmlFor="whatsappNumber" style={{ fontWeight: 'bold' }}>WhatsApp Number</label>
                    <input
                      type="text"
                      name="whatsappNumber"
                      id="whatsappNumber"
                      placeholder="Enter your WhatsApp number"
                      className="footer-input-1 input_1"
                      value={this.state.whatsappNumber || ""}
                      onChange={this.handleChange}
                      required
                    />
                    {this.state.errors.whatsappNumber && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>{this.state.errors.whatsappNumber}</div>
                    )}
                  </div>
                  <div className="col-md-4 col-sm-12 py-2">
                    <label htmlFor="email" style={{ fontWeight: 'bold' }}>Email ID</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter your email address"
                      className="footer-input-1 input_1"
                      value={this.state.email || ""}
                      onChange={this.handleChange}
                      required
                    />
                    {this.state.errors.email && (
                      <div style={{ color: "red", fontSize: "0.9em" }}>{this.state.errors.email}</div>
                    )}
                  </div>
                </div>
                <div className="form-check mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="optInAlerts"
                    name="optInAlerts"
                    checked={this.state.optInAlerts || false}
                    onChange={this.handleChange}
                    required
                  />
                  <label className="form-check-label" htmlFor="optInAlerts">
                    Opt in for weekly alerts via SMS, WhatsApp and Email to stay updated on our platform.<br />
                    <span style={{ color: 'red', fontSize: '0.9em' }}>
                      You must check this box to subscribe.
                    </span>
                  </label>
                  {this.state.errors.optInAlerts && (
                    <div style={{ color: "red", fontSize: "0.9em" }}>{this.state.errors.optInAlerts}</div>
                  )}
                </div>
                <div className="btn_footer text-center my-5">
                  <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
                    <Button
                      customClass="al_button_2"
                      buttonStyle="btn--outline"
                      buttonSize="btn--large"
                      text="Submit"
                      type="submit"
                    />
                    <Button
                      customClass="al_button_2 mx-3"
                      buttonStyle="btn--outline"
                      buttonSize="btn--large"
                      text="Reset"
                      type="reset"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="row contact_us mt-3">
              <div className="col-md-4 col-sm-6 border_right">
                <p>
                  Vishal Sharma<br></br>
                  partners@pulselabs.co.in
                </p>
              </div>
              <div className="col-md-4 col-sm-6 border_right text-center">
                {/* <p>Phone: 80734 61259</p> */}
              </div>
              <div className="col-md-4 col-sm-6">
                <p>
                  Shree Arcade, 2nd Floor,<br></br>
                  19th Main, Sector 4,<br></br>
                  HSR Layout, Bangalore
                </p>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default Footer;
